import {
    ClockSVGIcon,
    ContractSVGIcon,
    InvoiceSVGIcon,
    NoImageSVGIcon,
    PencilWithPathSVGIcon,
    ProfileSVGIcon,
} from '@/shared/assets'
import React from 'react'

export type IconProps = {
    checked?: boolean
    icon: keyof typeof icons
    error?: boolean
    waiting?: boolean
}

const icons = {
    clock: ClockSVGIcon,
    profile: ProfileSVGIcon,
    contract: ContractSVGIcon,
    invoice: InvoiceSVGIcon,
    noImage: NoImageSVGIcon,
    act: PencilWithPathSVGIcon,
}

const Icon: React.FC<IconProps> = ({
    checked = false,
    icon,
    error = false,
    waiting = false,
}) => {
    const StatusIcon = icons[icon]

    const colorMap = {
        error: { bg: '#FFE6E6', fg: '#FF5957' },
        waiting: { bg: '#35B2FF', fg: '#ffffff' },
        checked: { bg: '#B5E8D0', fg: '#47C58A' },
        default: { bg: '#E5E5E5', fg: '#B5B5B5' },
    } as const

    const state = error
        ? 'error'
        : waiting
          ? 'waiting'
          : checked
            ? 'checked'
            : 'default'
    const { bg: bgColor, fg: fgColor } = colorMap[state]

    return (
        <StatusIcon
            style={
                {
                    '--icon-bg': bgColor,
                    '--icon-fg': fgColor,
                } as React.CSSProperties
            }
        />
    )
}

export default Icon
